export var ConnectorType;
(function (ConnectorType) {
    ConnectorType["TYPE1"] = "type1";
    ConnectorType["TYPE2"] = "type2";
    ConnectorType["CCS"] = "ccs";
    ConnectorType["CHADEMO"] = "chademo";
    ConnectorType["TESLA_SUC"] = "tesla_suc";
    ConnectorType["TESLA_CCS"] = "tesla_ccs";
    ConnectorType["GB_T"] = "gb_t";
    ConnectorType["CCS2"] = "ccs2";
})(ConnectorType || (ConnectorType = {}));
